<template>
  <v-skeleton-loader
    v-if="skeleton"
    :loading="skeleton"
    type="table"
  />

  <v-data-table
    v-else
    ref="table"
    :key="keySortablePositions"
    v-bind="$attrs"
    :value="selected"
    :headers="tableHeaders"
    :items="items"
    :item-class="getItemClass"
    :expanded.sync="expanded"

    :server-items-length="pagination.count"
    :show-expand="showExpand"

    item-key="procedure_id"
    :loading="loading"

    :show-select="showSelect"
    :single-expand="singleExpand"

    :options="options"
    :footer-props="footerProps"
    :hide-default-footer="hideDefaultFooter"

    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :multi-sort="multiSort"

    class="b-table"
    v-on="listeners"
    @pagination="onChangePagination"
    @update:sort-desc="onSort"
  >
    <!--  -->

    <template #item.data-table-expand="props">
      <v-layout
        row
        align-center
        class="px-2"
        style="cursor: pointer;"
        @click.stop="onExpand(props, getData(props.item))"
      >
        <BTableButtonExpand
          :active="props.isExpanded"
          :disabled="!checkShowExpand(getData(props.item), props)"
        />

        <div>{{ props.item.name }}</div>
      </v-layout>
    </template>

    <template #item.sortable-positions>
      <v-icon
        class="js-sortable-positions-handle"
        :class="{ 'js-sortable-positions-handle--disabled': items.length < 2 }"
      >
        mdi-drag
      </v-icon>
    </template>

    <template #item.actions="{ header, item, index }">
      <div class="text-no-wrap">
        <template v-for="action in header.actions">
          <slot
            :name="`item.actions.${action.action}`"
            v-bind="{ action, header, item, index, data: getData(item) }"
          >
            <BTableButtonAction
              :key="action.action"
              :action="action"
              :index="index"
              :data="getData(item)"
              :list="list"
              v-on="$listeners"
              @change:positions="onChangePositions"
            />
          </slot>
        </template>
      </div>
    </template>

    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :data="getData(props.item)" :name="key" />
    </template>

    <!--  -->
  </v-data-table>
</template>


<script>
import BTable, { createActionHeader } from '@/components/common/BTable.vue'

const HEADER_TABLE_EXPAND = {
  text: 'Процедура',
  value: 'data-table-expand',
  sortable: false,
  width: '30%',
}

export default {
  name: 'BTableMarks',
  extends: BTable,
  computed: {
    tableHeaders() {
      // eslint-disable-next-line object-curly-newline
      const { actions, sortablePositions, items, showExpand } = this
      let headers = this.headers.slice()

      if (showExpand) {
        headers.unshift(HEADER_TABLE_EXPAND)
      }

      if (items.length && (actions?.length || sortablePositions || showExpand)) {
        const allActions = [].concat(actions || [])

        if (actions?.length) {
          const headerAction = createActionHeader(allActions, this.fullWidthActions)
          headers.push(headerAction)
        }
      }

      if (!items.length) {
        // если нет данных, то и сортировку отключим
        headers = headers.map((_) => ({ ..._, sortable: false }))
      }

      return headers
    },
  },
}
</script>
